import { cssVar } from '@chakra-ui/theme-tools';
import type { ComponentStyleConfig } from '@chakra-ui/react';

const $bg = cssVar('tooltip-bg');
const $fg = cssVar('tooltip-fg');
const $arrowBg = cssVar('popper-arrow-bg');

export const Tooltip: ComponentStyleConfig = {
  baseStyle: {
    bg: 'bg.elevated',
    color: 'text.primary',
    borderWidth: '1px',
    borderColor: 'border.muted',
    boxShadow: 'elevation.1',
    [$bg.variable]: 'var(--chakra-colors-bg-elevated)',
    [$fg.variable]: 'var(--chakra-colors-text-primary)',
    [$arrowBg.variable]: 'var(--chakra-colors-bg-elevated)',
  },
};
